<template>
  <div>
    <ui-button
      color="primary"
      class="ml-5"
      icon="icon-map"
      @click="facilitiesDialog = true"
    >
      {{ $t("message.reviews.categories.selectLocations") }}
    </ui-button>
    <FacilitiesDialog
      v-if="facilitiesDialog"
      show
      :selected-tab="selectedFacility"
      @selected="handleSelected"
      @close="facilitiesDialog = false"
    />
  </div>
</template>

<script>
export default {
  name: "ReviewsCategoriesFacilitiesDialogButton",
  components: {
    FacilitiesDialog: () =>
      import("@/components/Reviews/Categories/FacilitiesDialog.vue")
  },
  computed: {
    selectedFacility() {
      return this.$store.state.reviewsCategoriesAnalytics.selectedFacility;
    }
  },
  data() {
    return {
      facilitiesDialog: false
    };
  },
  methods: {
    handleSelected(event) {
      this.$emit("selected", event);
      this.facilitiesDialog = false;
    }
  }
};
</script>
